import $ from 'jquery';
import NewsVM from './news-vm'
import formSubmitHandlerFactory from "./submit-handler-factory";
import loadMoreFactory from './load-more-factory';
import initFilters from "./news-filter";

export const $newsContainer = $('#news');
export const $newsForm = $('#news-form');

if ($newsContainer.length > 0 && $newsForm.length > 0) {
    initFilters($newsForm);
    $newsForm.on('submit', formSubmitHandlerFactory($newsForm, NewsVM));
    NewsVM.$mount($newsContainer[0]);
    NewsVM.$on('load-more', loadMoreFactory($newsForm, NewsVM));
    $newsForm.submit();
}
